import { createContext } from 'react';
import { SIZES as BUTTON_SIZES } from '../Button/Button.constants';
import { ButtonSize } from '../Button';

export interface WixStyleReactDefaultsOverride {
  input: {
    size: 'tiny' | 'small' | 'medium' | 'large';
  };
  button: {
    size: ButtonSize;
  };
}

const context = createContext<WixStyleReactDefaultsOverride>({
  input: {
    size: 'medium',
  },
  button: {
    size: BUTTON_SIZES.medium,
  },
});
export const WixStyleReactDefaultsOverrideContext = context;
export const WixStyleReactDefaultsOverrideProvider = context.Provider;
export const WixStyleReactDefaultsOverrideConsumer = context.Consumer;
